import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box } from "@mui/material"
import { ImageSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { imageModal, titleModal } from "@signals"


export default function imageBannerColumn() {
    return {
        name: '',
        label: 'Image Banner',
        options: {
            filter: false,
            customBodyRowRender: (value, row) => {
                const handleClick = () => batch(() => {
                    imageModal.value = `${BACKEND_APIS.BANNERS}/image/${row.sovResourceID}`
                    titleModal.value = row.resourceType
                })

                return <Box>
                    <Box sx={{ display: 'flex', cursor: 'pointer', justifyContent: 'center' }} onClick={handleClick}>
                        <ImageSeeker
                            sx={{ height: 50, width: 50 }}
                            src={`${BACKEND_APIS.BANNERS}/image/${row.sovResourceID}`}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center'}}>
                        <Box sx={{ width: '50px', textAlign: 'center' }}>{row.resourceType}</Box>
                    </Box>
                </Box>
            }
        }
    }
}